import React from 'react'
import { Form, InputNumber } from 'antd'

/** Priority input shown on the Color/Branch (MATCH-capable) review steps. */
export const PriorityField = () => (
  <Form.Item
    label="Priority"
    name="priority"
    tooltip="Order in which mappings of the same type are evaluated (higher first)"
    rules={[{ required: true, message: 'Missing a priority' }]}
  >
    <InputNumber min={0} precision={0} style={{ width: '100%' }} />
  </Form.Item>
)
